module.exports = __webpack_public_path__ + "static/media/logo_google.f6ce5696.svg";